import { render, staticRenderFns } from "./approveDialog.vue?vue&type=template&id=3a419946&scoped=true&"
import script from "./approveDialog.vue?vue&type=script&lang=js&"
export * from "./approveDialog.vue?vue&type=script&lang=js&"
import style0 from "./approveDialog.vue?vue&type=style&index=0&id=3a419946&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a419946",
  null
  
)

export default component.exports